import { gql } from '@apollo/client';

export const FETCH_ALLOCATION_RULES = gql`
  query FetchAllocationRules($ruleType: String, $isActive: Boolean, $search: String, $limit: Int, $offset: Int) {
    fetchAllAllocationRules(ruleType: $ruleType, isActive: $isActive, search: $search, limit: $limit, offset: $offset) {
      items {
        id
        name
        description
        ruleType
        resultVia
        isActive
        priority
        conditions {
          param
          operator
          value
          cast
        }
        resultData
        conditionsSummary
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

export const FETCH_ALLOCATION_RULE = gql`
  query FetchAllocationRule($id: ID!) {
    fetchAllocationRule(id: $id) {
      id
      name
      description
      ruleType
      priority
      isActive
      resultVia
      resultData
      metadata
      conditions {
        param
        operator
        value
        cast
      }
      conditionsSummary
      createdAt
      updatedAt
    }
  }
`;

export const FETCH_ALLOCATION_ENGINE_STATUS = gql`
  query FetchAllocationEngineStatus {
    fetchAllocationEngineStatus {
      enabled
      activeRulesCount
      totalRulesCount
      hasActiveRules
      statusMessage
      totalConditions
      avgConditions
      priorityDistribution {
        high
        medium
        low
      }
      statusDistribution {
        activeCount
        activePercentage
        inactiveCount
        inactivePercentage
      }
    }
  }
`;

export const FETCH_ALLOCATION_INSTRUCTIONS = gql`
  query FetchAllocationInstructions {
    fetchAllocationInstructions {
      overview {
        title
        description
        sections {
          heading
          content
        }
      }
      operators {
        operator
        label
        description
        exampleValue
        castTypes
      }
      commonParameters {
        path
        label
        description
        exampleValue
        castType
      }
      examples {
        title
        description
        ruleConfig
      }
    }
  }
`;

export const TOGGLE_ALLOCATION_ENGINE = gql`
  mutation ToggleAllocationEngine($enabled: Boolean!) {
    toggleAllocationEngine(input: { enabled: $enabled }) {
      enabled
      message
      status {
        enabled
        activeRulesCount
        totalRulesCount
        hasActiveRules
        statusMessage
      }
    }
  }
`;

export const CREATE_ALLOCATION_RULE = gql`
  mutation CreateAllocationRule($input: CreateAllocationRuleInput!) {
    createAllocationRule(input: $input) {
      allocationRule {
        id
        name
        description
        ruleType
        priority
        isActive
        resultVia
        resultData
        conditionsSummary
      }
    }
  }
`;

export const UPDATE_ALLOCATION_RULE = gql`
  mutation UpdateAllocationRule($input: UpdateAllocationRuleInput!) {
    updateAllocationRule(input: $input) {
      allocationRule {
        id
        name
        description
        ruleType
        priority
        isActive
        resultVia
        resultData
        conditionsSummary
      }
    }
  }
`;

export const DELETE_ALLOCATION_RULE = gql`
  mutation DeleteAllocationRule($id: ID!) {
    deleteAllocationRule(input: { id: $id }) {
      success
      message
    }
  }
`;

export const ADD_ALLOCATION_CONDITION = gql`
  mutation AddAllocationCondition(
    $ruleId: ID!
    $param: String!
    $operator: String!
    $value: String!
    $cast: String
  ) {
    addAllocationCondition(
      input: {
        ruleId: $ruleId
        param: $param
        operator: $operator
        value: $value
        cast: $cast
      }
    ) {
      allocationRule {
        id
        conditions {
          param
          operator
          value
          cast
        }
        conditionsSummary
      }
    }
  }
`;

export const REMOVE_ALLOCATION_CONDITION = gql`
  mutation RemoveAllocationCondition($ruleId: ID!, $conditionIndex: Int!) {
    removeAllocationCondition(
      input: { ruleId: $ruleId, conditionIndex: $conditionIndex }
    ) {
      allocationRule {
        id
        conditions {
          param
          operator
          value
          cast
        }
        conditionsSummary
      }
    }
  }
`;

export const TEST_ALLOCATION_RULE = gql`
  mutation TestAllocationRule($input: TestAllocationRuleInput!) {
    testAllocationRule(input: $input) {
      testResult {
        matches
        orderId
        merchantId
        merchantName
        cityName
        result
        conditionResults {
          condition
          actualValue
          expectedValue
          matches
        }
      }
    }
  }
`;

